import React, { useEffect, useState } from 'react'
import { getApiHeader } from 'utlis/commonfunctions';
import axios from 'axios'
import Payment from './Components/Payment'
import Summary from './Components/Summary'
import YourMobileNumber from './Components/YourMobileNumber'
import YourTelsimSim from './Components/YourTelsim'
import Plans from './Components/Plan/Plans'
import IdValidation from './Components/IdValidation'
import CreateAccount from './Components/CreateAccount'
import StaffDetails from './Components/StaffDetails'
import HomeScreen from './Components/HomeScreen';






const SERVER_URL = process.env.REACT_APP_API_URL;
function WmePrepaidActivation() {
 
 
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activationSuccessMsg, setActivationSuccessMsg] = useState("")
  const [activationSuccessData,setActivationSuccessData] = useState([])
  const [iddCheck,setIddCheck] = useState(false)

   useEffect(() => {
    const userType = sessionStorage.getItem('userType');
    setStep(userType === "PAR" ? 1 : 0); 
}, []);









  const [retailerDetails,setretailerDetails] = useState(null);
  const getRetailerData = (data) => {
    setretailerDetails(data);
  };


  const [commonSession,setCommonSession] = useState(null);
  const getSession = (data) => {
    setCommonSession(data);
  };


  const [userAccountData,setUserAccountData] = useState([]);
  const accountData = (data) => {
    setUserAccountData(data);
  };



  const [planDetails,setplanDetails] = useState([]);
  const planData = (data) => {
    setplanDetails(data);
  };



  const [selectedPlanData,setSelectedPlanData] = useState([]);
  const PlanSelection = (data) => {
    setSelectedPlanData(data);
  };


  const [dvsdetails,setDvsdetails] = useState([]);
  const dvsEntries = (data) => {
    setDvsdetails(data);
  };
  

  const clearDvs = () => {
    setDvsdetails([]);
  };
 


  const [newMobile,setNewMobile] = useState(null);
  const selectedMobile = (data) => {
    setNewMobile(data);
  };
  


  const nextStep = () =>{setStep((prevStep) => prevStep + 1)} 
  const prevStep = () => setStep((prevStep) => prevStep - 1);


  




  return (
    <div>
      <div>


        {step=== 0&& <HomeScreen nextStep={nextStep}/>}
        {step === 1 && <YourTelsimSim nextStep={nextStep} prevStep={prevStep} commonSession={commonSession}  handleSession={getSession} handlePlanDetails={planData} handleRetailer={getRetailerData} />}
        {step === 2 && <Plans nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} planDetails={planDetails}  handlePlanSelection={PlanSelection} retailerDetails={retailerDetails} setIddCheck={setIddCheck}/>}
        {step === 3 && <YourMobileNumber nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} selectedPlanData={selectedPlanData} handleMobile={selectedMobile} newMobile={newMobile}  setStep={setStep}  iddCheck={iddCheck}  />}
        {step === 4 && <IdValidation nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} handleDvsEntry={dvsEntries} dvs_Details={dvsdetails} />}
        {step === 5 && <CreateAccount nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} retailerDetails={retailerDetails} />}
        {step === 6 && <StaffDetails nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} handleAccount={accountData} />}
        {step === 7 && <Payment nextStep={nextStep} prevStep={prevStep} userAccountData={userAccountData} selectedPlanData={selectedPlanData} setActivationSuccessMsg={setActivationSuccessMsg} setActivationSuccessData={setActivationSuccessData} planDetails={planDetails} commonSession={commonSession} dvsdetails={dvsdetails}  />}
        {step === 8 && <Summary nextStep={nextStep} prevStep={prevStep} commonSession={commonSession} userAccountData={userAccountData} activationSuccessMsg={activationSuccessMsg} selectedPlanData={selectedPlanData} activationSuccessData={activationSuccessData} planDetails={planDetails} clearDvsEntry={clearDvs} />}

        {loading && <p>Loading...</p>}
        {error && <p className="error">{error}</p>}

        
      </div>
    </div>
  );
}

export default WmePrepaidActivation;
